export default "__VITE_ASSET__a096680a__"